import React, { useMemo } from "react";
import { Tag } from "@/types/cloud";
import { Flex, Text } from "@chakra-ui/react";
import { colorSchemes } from "@/utils/colorSchemes";
import Avatar from "@/components/common/Avatar";
import { getFileUri } from "@/utils/helpers";

type TagProps = {
  onClick: () => void;
  isSelected: boolean;
  tag: Tag;
  hideName?: boolean;
};

export const TagComponent = ({
  onClick,
  isSelected,
  tag: { name, picture, tagGroup },
  hideName,
}: TagProps): JSX.Element => {
  const colorScheme = tagGroup?.colorScheme ?? "gray";
  const colors = useMemo(() => colorSchemes(colorScheme, true), [colorScheme]);

  return (
    <Flex
      align="center"
      borderRadius=".375rem"
      px=".75rem"
      py={2}
      mb={2}
      cursor="pointer"
      fontWeight={isSelected && "500"}
      bg={isSelected && "main.800"}
      color={isSelected && "#FFFFFF"}
      _hover={!isSelected && { bg: "light.100" }}
      transitionProperty="all"
      transitionDuration=".3s"
      transitionTimingFunction="cubic-bezier(.4,0,1,1)"
      onClick={onClick}
    >
      <Avatar
        src={picture ? getFileUri(picture) : null}
        name={name}
        size="sm"
        mr={hideName ? 0 : 4}
        p={1}
        {...colors}
      />
      {!hideName && <Text>{name}</Text>}
    </Flex>
  );
};
